var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "modal",
    attrs: {
      id: "documents-template-list-modal",
      "modal-dialog-scrollable": false,
      "modal-dialog-size": "xl",
    },
    on: { hidden: _vm.handleHidden },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _vm._v(
              "\n    " + _vm._s(_vm.$t("documents.templateEditor")) + "\n  "
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c(
              "b-row",
              { staticClass: "justify-content-start" },
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12" } },
                  [
                    _c(
                      "div",
                      { staticClass: "soft-bordered pb-3" },
                      [
                        _c(
                          "b-row",
                          { staticClass: "align-items-center" },
                          [
                            _c(
                              "b-col",
                              [
                                _c(
                                  "b-row",
                                  { staticClass: "align-items-center" },
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "5" } },
                                      [
                                        _c("request-list-select", {
                                          attrs: {
                                            "selected-request-list":
                                              _vm.selectedRequestList.name,
                                            "request-lists":
                                              _vm.documentRequestLists,
                                          },
                                          on: {
                                            change: _vm.handleSelectRequestList,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    !_vm.currentListIsDraft
                                      ? _c("inline-prompt", {
                                          attrs: {
                                            "action-type": "delete",
                                            "confirmation-text": _vm.$t(
                                              "documents.deleteTemplateConfirmation"
                                            ),
                                          },
                                          on: {
                                            accept: _vm.handleDeleteTemplate,
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("b-col", { attrs: { cols: "auto" } }, [
                              _c(
                                "div",
                                {
                                  attrs: { id: "modal-request-action-buttons" },
                                },
                                [
                                  _c(
                                    "b-row",
                                    { staticClass: "align-items-center" },
                                    [
                                      _c(
                                        "b-col",
                                        {
                                          staticClass:
                                            "d-flex justify-content-end",
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-sm ml-2 btn-primary",
                                              attrs: {
                                                disabled:
                                                  _vm.selectedRequestListEmpty,
                                              },
                                              on: {
                                                click:
                                                  _vm.handleSaveAsNewTemplate,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "documents.saveAsNewTemplate"
                                                    )
                                                  ) +
                                                  "\n                    "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("document-request-list", {
                      attrs: {
                        "document-request-list-name":
                          _vm.selectedRequestList.name,
                        "draft-document-request-list": _vm.currentListIsDraft,
                        "document-requests-ids":
                          _vm.selectedRequestListDocumentRequestIds,
                        "application-id": _vm.applicationId,
                        "client-username": _vm.clientUsername,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "12 col-sm-8 col-md-6 col-xl-4" } },
                  [
                    _c(
                      "div",
                      { staticClass: "soft-bordered ignore-drag pt-3 bb-0" },
                      [
                        _c("request-list-classification-select-container", {
                          attrs: { loading: _vm.creating },
                          on: {
                            change: _vm.handleAddRequestListClassification,
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "simple-button",
              {
                attrs: {
                  type: "primary btn-sm",
                  loading: _vm.creatingClassifications,
                  disabled: _vm.selectedRequestListEmpty,
                },
                on: { click: _vm.handleUseTemplate },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("documents.useThisTemplate")) +
                    "\n    "
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }